import axios from "axios";
import qs from "qs";
import { get } from "lodash";

const ARTICLES_LIST_LOAD = "ARTICLES_LIST_LOAD";
const ARTICLES_LIST_SUCCESS = "ARTICLES_LIST_SUCCESS";
const ARTICLES_LIST_FAILED = "ARTICLES_LIST_FAILED";
const ARTICLES_SET_LOADING = "ARTICLES_SET_LOADING";
const ARTICLES_LIST_HIGHTLIGHT = "ARTICLES_LIST_HIGHTLIGHT";

const ARTICLES_FORM_LOAD = "ARTICLES_FORM_LOAD";
const ARTICLES_FORM_SUCCESS = "ARTICLES_FORM_SUCCESS";
const ARTICLES_FORM_FAILED = "ARTICLES_FORM_FAILED";

const ARTICLE_DELETE_LOAD = "ARTICLE_DELETE_LOAD";
const ARTICLE_DELETE_SUCCESS = "ARTICLE_DELETE_SUCCESS";
const ARTICLE_DELETE_FAILED = "ARTICLE_DELETE_FAILED";

const ARTICLE_EDIT_LOAD = "ARTICLE_EDIT_LOAD";
const ARTICLE_EDIT_SUCCESS = "ARTICLE_EDIT_SUCCESS";
const ARTICLE_EDIT_FAILED = "ARTICLE_EDIT_FAILED";

const ARTICLE_VIEW_LOAD = "ARTICLE_VIEW_LOAD";
const ARTICLE_VIEW_SUCCESS = "ARTICLE_VIEW_SUCCESS";
const ARTICLE_VIEW_FAILED = "ARTICLE_VIEW_FAILED";

const ARTICLES_RESET = "ARTICLES_RESET";
const ARTICLES_RESET_FORM = "ARTICLES_RESET_FORM";

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit: process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: "",
  orderMode: "ASC",
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null,
  reload: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ARTICLES_RESET:
      return {
        ...initialState
      };
    case ARTICLES_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case ARTICLE_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case ARTICLES_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false,
        reload: false
      };
    case ARTICLE_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case ARTICLE_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case ARTICLES_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case ARTICLES_FORM_FAILED:
    case ARTICLE_EDIT_FAILED:
    case ARTICLE_DELETE_FAILED:
    case ARTICLES_LIST_FAILED:
    case ARTICLE_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case ARTICLES_LIST_HIGHTLIGHT:
      return {
        ...state,
        success: true,
        failed: false,
        loading: false,
        reload: true
      };
    case ARTICLES_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode,
        loading: false
      };
    case ARTICLE_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        failed: false,
        viewData: action.viewData,
        commentThread: action.commentThread || false,
        viewLoading: false
      };
    case ARTICLES_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case ARTICLE_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case ARTICLE_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case ARTICLES_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
};

export const reset = () => dispatch => {
  dispatch({
    type: ARTICLES_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: ARTICLES_RESET_FORM
  });
};

export const updateArticles = (model, id, data) => dispatch => {
  dispatch({
    type: ARTICLE_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios
    .put("/v1/articles/" + id, obj)
    .then(response => {
      dispatch({
        type: ARTICLE_EDIT_SUCCESS
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: ARTICLE_EDIT_FAILED,
        message: get(error, "response.data.message", null),
        formErrors: get(error, "response.data.form_errors", {})
      });
      throw error.response;
    });
};

export const viewArticles = id => dispatch => {
  dispatch({
    type: ARTICLE_VIEW_LOAD
  });
  return axios
    .get("/v1/articles/" + id)
    .then(response => {
      dispatch({
        type: ARTICLE_VIEW_SUCCESS,
        viewData: get(response, "data.data"),
        commentThread: get(response, "data.commentThread", false)
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: ARTICLE_VIEW_FAILED,
        message: get(error, "response.data.message", null)
      });
      throw error.response;
    });
};

export const createArticles = (model, data) => dispatch => {
  dispatch({
    type: ARTICLE_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios
    .post("/v1/articles", obj)
    .then(response => {
      dispatch({
        type: ARTICLE_EDIT_SUCCESS,
        id: get(response, "data.data.id", null)
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: ARTICLE_EDIT_FAILED,
        message: get(error, "response.data.message", null),
        formErrors: get(error, "response.data.form_errors", {})
      });
      throw error.response;
    });
};

export const articleDelete = id => dispatch => {
  dispatch({
    type: ARTICLE_DELETE_LOAD
  });
  return axios
    .delete("/v1/articles/" + id)
    .then(response => {
      dispatch({
        type: ARTICLE_DELETE_SUCCESS,
        id
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: ARTICLE_DELETE_FAILED,
        message: get(error, "response.data.message", null)
      });
      throw error.response;
    });
};

export const setLoading = loading => dispatch => {
  dispatch({
    type: ARTICLES_SET_LOADING,
    loading
  });
};

export const articlesHightLight = id => dispatch => {
  dispatch({
    type: ARTICLES_LIST_LOAD
  });
  return axios
    .put("/v1/articles/highlight/" + id)
    .then(response => {
      dispatch({
        type: ARTICLES_LIST_HIGHTLIGHT
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: ARTICLES_LIST_FAILED,
        message: get(error, "response.data.message", null)
      });
      throw error.response;
    });
};

export const articlesList = (
  page,
  keyword,
  sort,
  filters,
  perPage
) => dispatch => {
  dispatch({
    type: ARTICLES_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    "per-page": perPage
  };

  params[filters.model] = filters.filters;

  return axios
    .get(
      "/v1/articles",
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    )
    .then(response => {
      let sort = get(response, "data.sort", null),
        mode = "ASC";
      if (sort && sort.indexOf("-") !== -1) {
        mode = "DESC";
        sort = sort.substr(1);
      }
      dispatch({
        type: ARTICLES_LIST_SUCCESS,
        data: get(response, "data.data", null),
        page: get(response, "data.page", 0),
        limit: get(response, "data.per-page", 0),
        total: get(response, "data.total", 0),
        order: sort,
        orderMode: mode
      });
      return response; // todo  use response.data
    })
    .catch(error => {
      dispatch({
        type: ARTICLES_LIST_FAILED,
        message: get(error, "response.data.message", null)
      });
      throw error.response;
    });
};
